export const C_USE_MEDICINE_DEFAULT = [
  { dose: '', note: '', usage_time: 'morning' },
  { dose: '', note: '', usage_time: 'midday' },
  { dose: '', note: '', usage_time: 'afternoon' },
  { dose: '', note: '', usage_time: 'night' }
]
